import type { ITimeProviderFunc } from "./provider";

export const TimeProviderFactory: ITimeProviderFunc = ({
  dateLibrary,
  utcPlugin,
  timezonePlugin,
  isBetween,
  advancedFormat,
  relativeTime,
  duration,
  isToday,
}) => {
  dateLibrary.extend(utcPlugin);
  dateLibrary.extend(timezonePlugin);
  dateLibrary.extend(isBetween);
  dateLibrary.extend(advancedFormat);
  dateLibrary.extend(relativeTime);
  dateLibrary.extend(duration);
  dateLibrary.extend(isToday);

  const setTimezone: ISetTimezone = (timezone) => {
    if (timezone !== null && timezone !== undefined) {
      dateLibrary.tz.setDefault(timezone);
    }
  };

  const convertIntoLocalDateTime: IConvertIntoLocalDateTime = (
    dateTime,
    formatIn = "YYYY-MM-DD HH:mm:ss"
  ) => {
    try {
      if (!dateTime) throw Error("Date or time is required");
      // ["YYYY", "YYYY-MM-DD"] - add multiple format
      // true is for strictly follow format
      const date = dateLibrary(dateTime, formatIn).utc(true).tz();
      if (!date.isValid()) throw Error("Date or time is invalid");
      return date;
    } catch (err) {
      console.log(err);

      return undefined;
    }
  };

  const convertIntoUTCDateTime: IConvertIntoUTCDateTime = (
    dateTime,
    formatIn = "YYYY-MM-DD HH:mm:ss"
  ) => {
    try {
      if (!dateTime) throw Error("Date or time is required");
      // ["YYYY", "YYYY-MM-DD"] - add multiple format
      // true is for strictly follow format
      const date = dateLibrary(dateTime, formatIn).tz().utc();
      if (!date.isValid()) throw Error("Date or time is invalid");
      return date;
    } catch (err) {
      return undefined;
    }
  };

  const getUTCDateTime: IGetUTCDateTime = () => {
    return dateLibrary().tz().utc();
  };

  const getDateTime: IGetDateTime = () => {
    return dateLibrary().tz();
  };

  const getFacilityTime = (timezone: string) => {
    return dateLibrary().tz(timezone);
  };

  return {
    convertIntoLocalDateTime,
    convertIntoUTCDateTime,
    getDateTime,
    getUTCDateTime,
    setTimezone,
    getFacilityTime,
    dateLibrary,
  };
};
